import { jsx as _jsx } from "react/jsx-runtime";
// Token notes (P13-T6):
//   ambient  → bg-accent-soft / text-accent-deep  (both exist in design-tokens)
//   chilled  → bg-info-soft   / text-info         (info-deep absent; use info DEFAULT #3A5A78)
//   frozen   → bg-ink-100     / text-ink-700       (cool-soft/cool-deep absent; fall back to ink)
const META = {
    ambient: { label: "Ambient", bg: "bg-accent-soft", fg: "text-accent-deep" },
    chilled: { label: "Chilled", bg: "bg-info-soft", fg: "text-info" },
    frozen: { label: "Frozen", bg: "bg-ink-100", fg: "text-ink-700" },
};
export function StorageBadge({ type }) {
    const m = META[type];
    return (_jsx("span", { className: `inline-flex items-center rounded-pill px-2.5 py-1 text-caption font-medium ${m.bg} ${m.fg}`, children: m.label }));
}
